document.addEventListener('alpine:init', () => {
  Alpine.data('productGrid', () => ({
    loading: false,
    currentGridCount: 0,
    ghostSpan: 1,
    observer: null,

    init() {
      this.currentGridCount = parseInt(this.$refs.ghostCell.dataset.products) + parseInt(this.$refs.ghostCell.dataset.callouts);
      this.updateCount();
      this.updateGhostCell();
      window.addEventListener('resize', () => this.updateGhostCell());

      document.addEventListener('ajax:success', (e) => {
        if (e.detail.ok) {
          console.log('Grid updated successfully via AJAX');
          // Wait for DOM to be fully updated
          Alpine.nextTick(() => {
            this.updateGridCount();
            this.updateCount();
            this.updateGhostCell();
            this.updateFilteredState();
            // Announce grid update to screen readers
            const productCount = document.querySelectorAll('#productGrid .product-item .c-product-card').length;
            this.$refs.gridStatus.textContent = `Showing ${productCount} product${productCount !== 1 ? 's' : ''}`;
            // Clear announcement after a brief delay
            setTimeout(() => {
              this.$refs.gridStatus.textContent = '';
            }, 1000);
          });
        }
      });
    },

    updateGridCount() {
      // Always get fresh values from the DOM
      const products = parseInt(this.$refs.ghostCell.dataset.products) || 0;
      const callouts = parseInt(this.$refs.ghostCell.dataset.callouts) || 0;
      this.currentGridCount = products + callouts;
      console.log('Updated grid count:', this.currentGridCount);
    },

    setupGridObserver() {
      console.log("Setting up grid observer...");
      const productGrid = document.getElementById('productGrid');
      if (!productGrid) return;

      // Create observer to watch for grid changes
      this.observer = new MutationObserver((mutations) => {
        let shouldUpdate = false;
        
        mutations.forEach((mutation) => {
          // Check if child nodes were added/removed (products changed)
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            shouldUpdate = true;
          }
          
          // Check if ghost cell data attributes changed
          if (mutation.type === 'attributes' && 
              mutation.target === this.$refs.ghostCell &&
              (mutation.attributeName === 'data-products' || 
               mutation.attributeName === 'data-callouts')) {
            shouldUpdate = true;
          }
        });

        if (shouldUpdate) {
          console.log('Grid changed, updating...');
          this.updateGridCount();
          this.updateCount();
          this.updateGhostCell();
        }
      });

      // Observe the grid and the ghost cell
      this.observer.observe(productGrid, {
        childList: true,
        subtree: true
      });

      this.observer.observe(this.$refs.ghostCell, {
        attributes: true,
        attributeFilter: ['data-products', 'data-callouts']
      });
    },

    updateGhostCell() {
      const columns = window.innerWidth >= 1024 ? 4 : 2;

      // Count actual rendered grid items instead of data attributes
      const products = document.querySelectorAll('#productGrid .product-item').length;
      const smallCallouts = document.querySelectorAll('#productGrid .callout-item--small').length;
      const largeCallouts = document.querySelectorAll('#productGrid .callout-item--large').length;

      // Large callout: 2 cols × 2 rows (4 cells) on tablet/desktop, 2 cols × 1 row (2 cells) on mobile
      const largeCells = window.innerWidth < 768 ? 2 : 4;
      const totalCells = products + (smallCallouts * 2) + (largeCallouts * largeCells);

      const remainder = totalCells % columns;
      if (remainder === 0) {
        this.$refs.ghostCell.style.display = 'none';
      } else {
        this.$refs.ghostCell.style.display = 'block';
        this.$refs.ghostCell.style.gridColumn = `auto / span ${columns - remainder}`;
      }
    },

    async loadMore(event) {
      if (this.loading) return;
      
      const button = event.target;
      const nextPage = button.dataset.nextPage;
      const loadUrl = new URL(window.location);
      loadUrl.searchParams.set('page', nextPage);
      const url = loadUrl.toString();
      this.loading = true;
      this.$refs.mainProductGrid.setAttribute('aria-busy', 'true');
      this.$refs.gridStatus.textContent = 'Loading more products';
      button.textContent = 'Loading...';
      
      try {
        const response = await fetch(url);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Track current product count before adding new ones
        const currentProductCount = document.querySelectorAll('#productGrid .product-item').length;
        
        // Extract new products and callouts (excluding empty cells)
        const newProducts = doc.querySelectorAll('#productGrid .product-item');
        const productGrid = document.getElementById('productGrid');
        
        // Add new products with animation
        newProducts.forEach((product, index) => {
          const clone = product.cloneNode(true);
          // Reset Alpine data for animations
          clone.setAttribute('x-data', '{ loaded: false }');
          clone.setAttribute('x-init', `setTimeout(() => loaded = true, ${index * 50})`);
          clone.setAttribute('x-bind:class', `loaded ? 'loaded' : ''`);
          productGrid.appendChild(clone);
        });

        // Move ghost cell to the end
        productGrid.appendChild(this.$refs.ghostCell);
        
        // Update or hide the load more button
        const newFooter = doc.querySelector('.product-grid-footer');
        const currentFooter = document.querySelector('.product-grid-footer');
        if (newFooter && currentFooter) {
          currentFooter.innerHTML = newFooter.innerHTML;
        }
        
        // Re-initialize Alpine on new elements
        Alpine.initTree(productGrid);
        
        // Move focus to the first newly added item for keyboard users.
        // Focus the .product-item WRAPPER (not the inner .c-product-card__link):
        // focusing the link triggers the card's :focus-within rule, which is the
        // same rule that drives the hover reveal — leaving the first new card stuck
        // showing its secondary (hover) image. The wrapper is the card's parent, so
        // :focus-within on .c-product-card never fires.
        const allProductItems = document.querySelectorAll('#productGrid .product-item');
        const firstNewProduct = allProductItems[currentProductCount];
        if (firstNewProduct) {
          firstNewProduct.setAttribute('tabindex', '-1');
          firstNewProduct.focus({ preventScroll: true });
        }
        
        // Update count
        this.updateCount();
        
        // Re-handle empty cells after new products loaded
        this.updateGhostCell();
        
      } catch (error) {
        console.error('Failed to load more products:', error);
        button.textContent = 'Load More';
      } finally {
        this.loading = false;
        this.$refs.mainProductGrid.removeAttribute('aria-busy');
        this.$refs.gridStatus.textContent = '';
      }
    },

    updateCount() {
      const count = document.querySelectorAll('#productGrid .product-item .c-product-card').length;
      const currentSpan = document.querySelector('.product-status__current');
      if (currentSpan) {
        currentSpan.textContent = count;
      }
    },

    updateFilteredState() {
      const productCount = document.querySelectorAll('#productGrid .product-item .c-product-card').length;

      // Update header count
      const headerCount = document.querySelector('.product-grid-header__count');
      if (headerCount) {
        headerCount.textContent = `${productCount} ${productCount !== 1 ? 'Products' : 'Product'}`;
      }

      // Update footer total
      const totalSpan = document.querySelector('.product-status__total');
      if (totalSpan) {
        totalSpan.textContent = productCount;
      }

      // Hide Load More if all filtered results fit on one page
      const loadMoreButton = document.querySelector('.load-more-button');
      if (loadMoreButton) {
        const newProducts = document.querySelectorAll('#productGrid .product-item').length;
        const ghostCell = this.$refs.ghostCell;
        const totalProducts = parseInt(ghostCell.dataset.products) || 0;
        if (newProducts >= totalProducts) {
          loadMoreButton.style.display = 'none';
        } else {
          loadMoreButton.style.display = '';
        }
      }
    },

    get productsShown() {
      return document.querySelectorAll('#productGrid .product-item .c-product-card').length;
    }
  }));
});